import React, { useEffect, useState } from "react";
import {
  useGetCategoriesQuery,
  useGetMenuListQuery,
} from "../../products/productSlice";

import "./ProductsCategory.css";
import axios from "axios";
import Slider from "react-slick";

import catagoryShape from "../../../assets/img/category/catagory-card-shape.png";

import service1 from "../../../assets/img/category/Aspirin-pills.webp";
import service2 from "../../../assets/img/category/antibiotic.webp";
import service3 from "../../../assets/img/category/antiseptic-liquid.webp";
import service4 from "../../../assets/img/category/antivirals.jpg";
import service5 from "../../../assets/img/category/Aspirin-pills.webp";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { base_url } from "../../../server";

const pharmaCategories = [
  { id: 1, title: "Analgesics", imgUrl: service1 },
  { id: 2, title: "Antibiotics", imgUrl: service2 },
  { id: 3, title: "Antiseptics", imgUrl: service3 },
  { id: 4, title: "Antivirals", imgUrl: service4 },
  // { id: 5, title: "Antifungals", imgUrl: "https://example.com/images/antifungals.png" },
  // { id: 6, title: "Cardiovascular Drugs", imgUrl: "https://example.com/images/cardiovascular.png" },
  // { id: 7, title: "Corticosteroids", imgUrl: "https://example.com/images/corticosteroids.png" },
  // { id: 8, title: "Diuretics", imgUrl: "https://example.com/images/diuretics.png" },
  // { id: 9, title: "Gastrointestinal Drugs", imgUrl: "https://example.com/images/gastrointestinal.png" },
  // { id: 10, title: "Hormones", imgUrl: "https://example.com/images/hormones.png" },
  // { id: 11, title: "Immunosuppressants", imgUrl: "https://example.com/images/immunosuppressants.png" },
  // { id: 12, title: "Insulins", imgUrl: "https://example.com/images/insulins.png" },
  // { id: 13, title: "Muscle Relaxants", imgUrl: "https://example.com/images/muscle-relaxants.png" },
  // { id: 14, title: "Psychotropics", imgUrl: "https://example.com/images/psychotropics.png" },
  // { id: 15, title: "Respiratory Drugs", imgUrl: "https://example.com/images/respiratory.png" },
  // { id: 16, title: "Vitamins & Supplements", imgUrl: "https://example.com/images/vitamins.png" }
];

function ProductsCategory() {
  // const { isLoading, error } = useGetCategoriesQuery();

  const [categoriesDatas, setCateData] = useState(null);
  const baseUrl = base_url();
  const getcateData = async () => {
    try {
      const res = await axios.get(`${baseUrl}category/public`, {
        withCredentials: true,
      });
      setCateData(res.data);
    } catch (error) {}
  };
  useEffect(() => {
    getcateData();
  }, []);

  const settings = {
    speed: 500,
    slidesToShow: 4, // Number of items to show on desktop
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // Screen size for tablets
        settings: {
          slidesToShow: 3, // Number of items to show on tablets
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Screen size for mobile devices
        settings: {
          slidesToShow: 2, // Number of items to show on mobile
          slidesToScroll: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 500, // Screen size for mobile devices
        settings: {
          slidesToShow: 1, // Number of items to show on mobile
          slidesToScroll: 1,
        },
      },
    ],
  };

  const { t, i18n } = useTranslation();
  return (
    <>
      <section className="serviceList p-30 bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="fisherman-content">
                <span>EHL Life Sciences Pvt Ltd </span>
                <h3> {t("Our category")} </h3>
                <p></p>
              </div>
            </div>

            <div className="row">
              {/* {isLoading && (
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {error && (
                <h4 style={{ textAlign: "center", color: "red" }}>
                  Server Error
                </h4>
              )} */}
            </div>
            <div className="categoryWrapper">
              <Slider {...settings}>
                {categoriesDatas?.reverse().map((item, i) => {
                  return (
                    <div className="mediaQuaryClas" key={i}>
                      <Link to={`/product/category/${item.uid}/${item?.slug}`}>
                        <div className="serviceItemIcon">
                          <img
                            src={item?.icon?.url}
                            alt="Product"
                            // style={{ height: "135px" }}
                            className="img-fluid"
                          />
                        </div>
                        <div className="serviceItemText">
                          <h5>
                            <Link to="/products">
                              {item?.name}
                              <i className="ri-arrow-right-up-fill"></i>
                            </Link>
                          </h5>
                        </div>
                      </Link>
                    </div>
                  );
                })}
                {/* {pharmaCategories.map((item) => {
                  return (
                    <div className="mediaQuaryClas" key={item.i}>
                      <Link to={`/`}>
                        <div className="serviceItemIcon">
                          <img
                            src={item.imgUrl}
                            alt="Product"
                            className="img-fluid"
                          />
                        </div>
                        <div className="serviceItemText">
                          <h5>
                            <Link to="/products">{item.title}</Link>
                          </h5>
                          <p>12+ Products</p>
                        </div>
                      </Link>
                    </div>
                  );
                })} */}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductsCategory;
